export default __webpack_public_path__ + "static/media/logo-dark.4e471040.png";